import BaseModal from '../Modal/Modal'
import styles from './Loader.module.less'

export type LoaderPropsType = {
    title: string
    width?: string
}

export const Loader: React.FC<LoaderPropsType> = (props: LoaderPropsType) => {
    return (
        <BaseModal
            data-testid="loader-wrapper"
            visible={true}
            disableAnimation={true}
            closable={false}
            width={props.width ?? '270px'}
            className={styles['root']}
            children={
                <div className={styles['modal']} data-testid="loader-wrapper">
                    <span className={styles['text']}>{props.title}</span>
                    <span className={styles['loader']}></span>
                </div>
            }
        />
    )
}
